import { createFormHook, createFormHookContexts } from "@tanstack/solid-form";
import type { Component } from "solid-js";
import {
  FieldContainer,
  FieldContainerLabel,
  FieldInfo,
  Input,
} from "@/components/ui/input";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

interface TextFieldProps {
  label: string;
  placeholder?: string;
  helpText?: string;
}

function TextField(props: TextFieldProps) {
  const field = useFieldContext<string>();
  return (
    <FieldContainer>
      <FieldContainerLabel for={field().name}>
        {props.label}
      </FieldContainerLabel>
      <Input
        id={field().name}
        name={field().name}
        value={field().state.value ?? ""}
        onInput={(e) => field().handleChange(e.target.value)}
        onBlur={() => field().handleBlur()}
        onChange={(e) => field().handleChange(e.target.value)}
        placeholder={props.placeholder}
      />
      <FieldInfo field={field()} helpText={props.helpText} />
    </FieldContainer>
  );
}

export const { useAppForm, withForm, withFieldGroup } = createFormHook({
  fieldContext,
  formContext,
  fieldComponents: { TextField } as Record<string, Component<TextFieldProps>>,
  formComponents: {},
});
